import {axiosBffFetch, FetcherOptions} from '../../axios/axiosBffFetch';
import type {ApiResultVo} from '../../common/shared/api/nicolas/vo/ApiResultVo.interface';
import type {HelixTodayGiftDto} from '../../common/shared/api/nicolas/vo/HelixTodayGiftDto.interface';
import type {TodayGiftDto} from '../../common/shared/api/nicolas/vo/TodayGiftDto.interface';
import {
  FreeTicketType,
  TicketFreeMutationInput,
} from '../../graphql/generated/types';

/**
 * 무료 이용권 수령
 *
 * Origin: pageNicolasApi.receiveFreeTicket
 * API: POST /api/v1/ticket/free
 */
export async function postTicketFree(
  {
    ticketUid,
    seriesId,
    type = FreeTicketType.TodayGift,
  }: TicketFreeMutationInput,
  options?: FetcherOptions
): Promise<ApiResultVo & {result: TodayGiftDto | HelixTodayGiftDto}> {
  const typeMap: Record<FreeTicketType, 'TODAY_GIFT' | 'HELIX_GIFT'> = {
    [FreeTicketType.TodayGift]: 'TODAY_GIFT',
    [FreeTicketType.HelixGift]: 'HELIX_GIFT',
  };

  const response = await axiosBffFetch(
    '/api/gateway/api/v1/ticket/free',
    {
      method: 'POST',
      data: {
        uid: ticketUid,
        series_id: seriesId,
        ...(typeMap[type] && {type: typeMap[type]}),
      },
    },
    options
  );
  return response.data;
}
